<template>
	<v-row justify="center">
		<v-dialog v-if="dialog" v-model="dialog" persistent max-width="400">
			<v-card>
				<v-card-title v-if="action == 'add'" class="headline">Tambah Produk</v-card-title>
				<v-card-title v-else class="headline">Edit Produk</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-row>
								<v-col cols="12" sm="12" md="12" class="pb-0">
									<v-text-field outlined dense @focus="() => responseError.code=''" :error-messages="responseError.code" v-model="paramAdd.code" label="Kode Produk" color="cyan darken-2"></v-text-field>
								</v-col>
								<v-col cols="12" sm="12" md="12" class="pb-0 text-capitalize">
									<v-text-field outlined dense @focus="() => responseError.name=''" :error-messages="responseError.name" v-model="paramAdd.name" label="Nama Produk" color="cyan darken-2"></v-text-field>
								</v-col>
								<v-col cols="12" sm="12" md="12" class="pb-0">
									<v-autocomplete :items="listProductUnit" v-model="paramAdd.unit" label="Satuan Produk" no-data-text="Tidak ada data yang sesuai" @focus="() => responseError.unit=''" :error-messages="responseError.unit" outlined dense color="cyan darken-2" item-color="cyan darken-4">
									</v-autocomplete>
								</v-col>
								<v-col cols="12" sm="12" md="12" class="pb-0">
									<v-currency-field outlined dense @focus="() => responseError.price=''" :error-messages="responseError.price" v-model.lazy="paramAdd.price" label="Harga Produk (Rp)" color="cyan darken-2"></v-currency-field>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="px-3">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Batal</v-btn>
					<v-btn dark color="cyan darken-4" depressed class="text-capitalize" @click.stop="save">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {
			page: 1,
			limit: "10",
			params: [],
			area_selected : '',
			provins : '',
			kota : '',
			subdistrict_selected : '',
			snackbarClass : "green accent-4",
			snackbar: false,
			text : "",
			timeout: 2000,
			OptionUnit : ['pcs', 'dus'],
			paramAdd: {
				code: '',
				name: '',
				price : '',
				unit: '',
			},
		}
	},
	props: {
		dialog: Boolean,
		editValue: Object,
		action: String
	},
	computed: {
		...mapState('supplierProduct', ['responseError', 'response', 'listProductUnit']),
	},
	methods: {
		hideDialog(){
			this.$emit('hideDialog')
		},
		resetParamAdd() {
			this.paramAdd = {
				code: '',
				name: '',
				price : '',
				unit: '',
			}
		},
		save(){
			this.paramAdd.price = this.paramAdd.price
			this.$emit('saveProduct', this.paramAdd)
		}
	},
	watch: {
		response:{
			deep: true,
			handler: function(val) {
				if (val.code == 200) {
					this.resetParamAdd()
					this.$emit('hideDialog')
				}
			}
		},
		editValue(val){
			this.resetParamAdd()
			if (Object.keys(val).length > 0 ) {
				this.paramAdd = val
			}
		}
	},
	created() {
	}
}
</script>